<template>
  <q-dialog
    v-if="packageVoucher"
    v-model="shown"
  >
    <q-card
      :style="$register ? 'min-width: 50%' : 'min-width: 30%'"
    >
      <q-card-section v-if="packageVoucher.vouchers.data.length !== 0">
        <div class="text-h6 text-center">
          {{ $t('voucherPackage.packageNameHeading', { name: packageVoucher.voucherPackage.name }) }}
        </div>
        <div class="text-subtitle2 text-center">
          {{ $t('voucherPackage.voucherTypeHeading', { type: packageVoucher.vouchers.data[0].voucherType.name }) }}
        </div>
      </q-card-section>
      <q-card-section>
        <q-scroll-area style="height: 40vh">
          <q-list
            bordered
            separator
          >
            <q-item
              v-for="voucher in voucherPackageOrdered"
              :key="voucher.id"
              class="space-between row"
            >
              <q-item-section
                v-if="$register"
              >
                <div>
                  {{ voucher.uid }}
                </div>
              </q-item-section>
              <q-item-section>
                <div v-if="!voucher.redeemedAt">
                  {{ $t('voucherPackage.stateNotRedeemed', { state: $_.startCase(voucher.state) }) }}
                </div>
                <div v-else>
                  {{ $t('time.redeemedAtTime', { time: voucher.redeemedAt.inTimeZone(currentSite.timeZone) }) }}
                </div>
              </q-item-section>
              <q-item-section class="col-4">
                <q-btn
                  v-if="order.isVoucherApplied(voucher)"
                  :label="$t('order.actions.appliedToOrder')"
                  dense
                  text-color="positive"
                  disable
                />
                <q-btn
                  v-else-if="voucher.state !== 'valid'"
                  :label="$t('voucherPackage.errors.notValid')"
                  text-color="negative"
                  disable
                />
                <q-btn
                  v-else-if="!voucher.redeemedAt"
                  outline
                  :label="$t('payment.actions.redeem')"
                  @click="order.addIndependentVoucher(voucher); $emit('add-voucher', voucher)"
                />
                <q-btn
                  v-else
                  disable
                  :label="$t('payment.actions.redeemed')"
                  class="text-grey"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </q-scroll-area>
      </q-card-section>
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          :label="$t('voucherPackage.actions.selectAllCountNotRedeemed', { count: order.addVoucherPackage(packageVoucher, false) })"
          :disable="order.addVoucherPackage(packageVoucher, false) === 0"
          color="primary"
          :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
          @click="order.addVoucherPackage(packageVoucher); $emit('add-voucher-package', packageVoucher)"
        />
        <q-btn
          v-close-popup
          :label="$t('actions.close')"
          color="secondary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>

export default {
  name: 'VoucherPackageDialog',
  components: {
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  emits: ['add-voucher', 'add-voucher-package'],
  data () {
    return {
      shown: false,
      packageVoucher: null
    }
  },
  computed: {
    voucherPackageOrdered () {
      if (!this.packageVoucher) return
      return _.orderBy(this.packageVoucher.vouchers.data, ['redeemedAt'], ['desc'])
    }
  },
  methods: {
    show (packageVoucher) {
      if (!packageVoucher) return
      this.packageVoucher = packageVoucher
      this.shown = true
    }
  },
  configuration: ['currentCircuit', 'currentSite']
}
</script>
